module.exports = __webpack_public_path__ + "static/media/icon-payments.5b563919.svg";